<template>
    <div class="activate-ig-wrapper">
        <a-result
            status="404"
            :title="$t('settings.instagramAlertTitle')"
            :sub-title="$t('settings.instagramAlertDesc')"
        >
            <template #extra>
                <a-button type="primary" @click="$router.push('/integrations/instagram')">
                    {{ $t("settings.instagramActivateText") }}
                </a-button>
            </template>
        </a-result>
    </div>
</template>

<script>
export default {
    name: "ActivateInstagramAlert",
};
</script>

<style lang="scss">
.activate-ig-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    min-height: 100vh;
    width: 100%;
}
</style>
